import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { userWithQualificationSelector } from './selectors/user';

/**
 * Query the user by id.
 * @param userId id of the user.
 * @returns found user result.
 */
const useQueryUserById = (onError: (e: ApolloError) => void, userId?: string) =>
  useTypedQuery(
    {
      user_by_pk: [
        {
          id: userId,
        },
        userWithQualificationSelector,
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: {
        onError,
        skip: userId === undefined,
      },
    }
  );

export default useQueryUserById;
